import { BackendAlarm } from './alarm-definitions/backend-alarm';
import { AlarmMessage } from './alarm-message';

/**
 * User disabled alarms are shown as inactive in UI, even the might be
 * actually active. The userdisabled field isn't returned from backend if
 * it's not set, so this function can be used to clarify determining the
 * "activity status displayed to user".
 */
export const isAlarmActiveForUser = (alarm: BackendAlarm) =>
  (alarm?.userdisabled === undefined || alarm?.userdisabled === null) // If userdisabled field is set
    ? alarm?.active                 // then use the original active value
    : !alarm.userdisabled;         // else use the activity status that user has set